const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/** Split on newlines / commas / semicolons / spaces; trim; validate; dedupe (order preserved). */
export function parseEmailList(raw: string): string[] {
  const parts = raw.split(/[\s,;\n\r]+/).map(s => s.trim()).filter(Boolean);
  const seen = new Set<string>();
  const out: string[] = [];
  for (const p of parts) {
    const lc = p.toLowerCase();
    if (seen.has(lc)) continue;
    if (!EMAIL_RE.test(p)) continue;
    seen.add(lc);
    out.push(p);
  }
  return out;
}

/** Remove primary recipient from CC list (dedupe blind copies). */
export function filterCcVsPrimary(cc: string[], primaryEmail: string): string[] {
  const px = primaryEmail.trim().toLowerCase();
  return cc.filter(e => e.trim().toLowerCase() !== px);
}
